





















































import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class CheckDialog extends Vue {
  private visible = false;
  newAssessType: any = '';

  formData: any = {
    assessProject: '',
  };

  choiceList: any = [];
  data: any = [];
  choiceThemeList: any = [];
  selectObj: any = {};

  private async showDialog(data: any) {
    this.selectObj = {};
    this.formData = {};
    this.data = [];
    this.visible = true;
    this.newAssessType = data;
    this.getChoiceThemeList(data);
  }

  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange(val: any) {
    if (val.length > 1) {
      (this.$refs['multipleTable'] as any).clearSelection();
      (this.$refs['multipleTable'] as any).toggleRowSelection(val[val.length - 1]);
    }
    // this.selectObj 就是选中的对象数据
    this.selectObj = val[val.length - 1];
    if (!this.selectObj) {
      this.selectObj = {};
    }
  }

  currentChange(val: any) {
    (this.$refs['multipleTable'] as any).toggleRowSelection(val);
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    if (this.selectObj.hasOwnProperty('assessProject')) {
      this.$emit('getData', this.selectObj);
      this.visible = false;
    } else {
      this.$message.warning('请先选择考核内容项');
    }
  }

  private getChoiceThemeList(data: any) {
    safetyAndEnvironmentAssessmentServer.getAssessStandConfigNewAll({ assessType: data }).then((res: any) => {
      if (res.code === '200') {
        this.choiceThemeList = res.data;
      } else {
        this.$message.warning(res.data.msg);
      }
    });
  }

  private changChoiceTheme(data: any) {
    safetyAndEnvironmentAssessmentServer
      .getAssessStandConfigAll({
        assessType: this.newAssessType,
        assessProject: data,
      })
      .then((res: any) => {
        this.data = this.mergeTableRowMethod(res.data, ['assessProject']);
      });
  }

  // 被合并行的样式
  mergeTableRowCss({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0 || columnIndex === 1) {
      return 'table-header-css';
    }
  }
  // elementUI的合并行方法
  mergeTableRow({ row, column, rowIndex, columnIndex }: any) {
    const span = column['property'] + '-span';
    if (row[span]) {
      return row[span];
    }
  }
  // 封装合并行逻辑
  mergeTableRowMethod(data: any, merge: any) {
    if (!merge || merge.length === 0) {
      return data;
    }
    merge.forEach((m: any) => {
      const mList: any = {};
      data = data.map((v: any, index: any) => {
        const rowVal: any = v[m];
        if (mList[rowVal] && mList[rowVal].newIndex === index) {
          mList[rowVal]['num']++;
          mList[rowVal]['newIndex']++;
          data[mList[rowVal]['index']][m + '-span'].rowspan++;
          v[m + '-span'] = {
            rowspan: 0,
            colspan: 0,
          };
        } else {
          mList[rowVal] = { num: 1, index: index, newIndex: index + 1 };
          v[m + '-span'] = {
            rowspan: 1,
            colspan: 1,
          };
        }
        return v;
      });
    });
    return data;
  }
}
